var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"parent-app"},[_c('HeaderComponent'),_c('SideBarComponent'),_c('div',{staticClass:"main-content",style:(!_vm.drawer?'padding:20px 30px' :'')},[_c('section',{staticClass:"section"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }